<template>
	<div class="forth_container">
    <div v-if="readyPay" class="count_down_box">订单支付剩余时间：<span>{{content}}</span></div>
    <div v-if="!readyPay && !submitSuccess" class="al_pay_error">赚钱任务已失效，请重新提交...</div>
    <div v-if="submitSuccess" class="al_pay">赚钱任务已提交审核，请耐心等待...</div>
    <div class="order_infor">
      <p>订单编号：{{orderInfo.task_no}}</p>
      <p>生成时间：{{orderInfo.created_at}}</p>
      <p>支付内容：{{orderInfo.content}}</p>
      <p>任务名称：{{orderInfo.task_species_name}}</p>
      <p>支付金额：<span>{{orderInfo.total_fee/100}}元</span></p>
      <div class="pay_way">
        <h6>支付方式</h6>
        <div class="pay_way_container">
          <div class="pay_way_item" v-for="(item,index) in typeList.payTypeList" :key="index">
            <div class="icon_type">
              <i class="el-icon-money"></i><span>账户余额</span>
            </div>
            <div class="money">{{orderInfo.balance}}元</div>
          </div>
        </div>
      </div>
      <slot v-if="readyPay && !submitSuccess" name="handle"></slot>
      <slot name="finished"></slot>
    </div>
	</div>
</template>

<script>
  import "@/shared/plugins/element"
	export default {
		props:{
			orderInfo:{
        type:Object,
        default:()=>{}
      },
      //类型
      typeList:{
        type:Object,
        default:()=>{}
      },
      readyPay:{
        type:Boolean,
        default:true
      },
      submitSuccess:{
        type:Boolean,
        default:false
      },
		},
		data(){
			return {
				curStartTime: '',
        content:'',
        endText:'已结束'
			}
		},
    mounted() {
      this.countdowm(this.orderInfo.pay_expired_time);
    },
		methods:{
			countdowm(timestamp){
        let self = this;
        if(this.readyPay){
          let timer = setInterval(function(){
          let nowTime = new Date();
          let endTime = new Date(timestamp * 1000);
          let t = endTime.getTime() - nowTime.getTime();
          if(t>0){
              let day = Math.floor(t/86400000);
              let hour=Math.floor((t/3600000)%24);
              let min=Math.floor((t/60000)%60);
              let sec=Math.floor((t/1000)%60);
              hour = hour < 10 ? "0" + hour : hour;
              min = min < 10 ? "0" + min : min;
              sec = sec < 10 ? "0" + sec : sec;
              let format = '';
              if(day > 0){
                 format =  `${day}天${hour}小时${min}分${sec}秒`;
              }
              if(day <= 0 && hour > 0 ){
                 format = `${hour}小时${min}分${sec}秒`;
              }
              if(day <= 0 && hour <= 0){
                 format =`${min}分${sec}秒`;
              }
              self.content = format;
              }else{
                clearInterval(timer);
                self.content = self.endText;
                self.$emit('timeout',false)
                self._callback();
              }
           },1000);
        }else{
          clearInterval(timer);
        }
       }
		}
	}
</script>

<style scoped="scoped">
  .forth_container{padding-top: 20px;}
  .count_down_box,.al_pay,.al_pay_error{height: 100px;background: #b3dcff;font-size: 20px;font-weight: 600;width: 600px;margin: 0 auto;line-height: 100px;text-align: center;
  margin-bottom: 20px;}
  .al_pay{background: lightgreen;}
  .count_down_box span{color: coral;font-weight: 600;font-size: 18px;}
  .order_infor{padding-left: 80px;}
  .order_infor p span{color: crimson;font-weight: 600;}
  .al_pay_error{background: #DC143C;color: #fff;}
  .pay_way_container{padding-top: 10px;padding-bottom: 10px;}
  .pay_way_item{ width: 150px;height: 80px;border: 1px solid #35B5FE;border-radius: 4px;padding-top: 15px;}
  .icon_type{ display: flex;flex-direction: row;justify-content: center;align-items: center; }
  .pay_way_item span{margin-left: 10px;}
  .pay_way_item .money{text-align: center;margin-top: 5px;}
</style>
